import { Tools } from 'wax-prosemirror-core';

class ReferenceManagerTool extends Tools {
  title = 'Manage References';
  icon = 'note';
  name = 'ReferenceManager';
  label = 'References';

  get run() {
    return (state, dispatch) => {
      const openReferenceManager = this.container.get('OpenReferenceManager');
      openReferenceManager();
      return true;
    };
  }

  get active() {
    return () => false;
  }

  select = () => true;
}

export default ReferenceManagerTool;
